import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/store/types';
import { BrowserService } from 'src/app/core/browser.service';
import { TranslateService } from '@ngx-translate/core';
import * as ColorActions from 'src/app/store/color-theme/actions';
import * as LanguageActions from 'src/app/store/language/actions';
import { PageService } from 'src/app/core/page/page.service';
import { CookieConsentComponent } from '../cookie-consent/cookie-consent.component';

@Component({
    selector: 'app-page',
    templateUrl: './page-layout.component.html',
    styleUrls: ['./page-layout.component.scss'],
    imports: [
        HeaderComponent,
        RouterOutlet,
        FooterComponent,
        CookieConsentComponent,
    ]
})
export class PageLayoutComponent {

  constructor(
    private readonly _store: Store<AppStateInterface>,
    private readonly browserService: BrowserService,
    private readonly _pageService: PageService,
    private _router: Router,
    private _translateService: TranslateService,){}



  ngOnInit(): void {
    this.initColorTheme();
    this.initLanguage();
  }

  /**
   * if color-theme exists it will set the global variable to this value
   * if it does not exists then fetch the required color-theme from prefers-color-scheme and
   * set it in local storage
   */
  private initColorTheme(){
    let colorTheme = this.browserService.localStorageGetItem('color-theme')
    if(colorTheme){
      this._store.dispatch(
        ColorActions.setColorTheme({ selectedColor: colorTheme }),
      );
    } else {
      const mediaQueryList = this.browserService.matchMedia('(prefers-color-scheme: dark)');
      colorTheme = mediaQueryList?.matches ? 'dark' : 'light'
      this.browserService.localStorageSetItem('color-theme', colorTheme)
      this._store.dispatch(
        ColorActions.setColorTheme({ selectedColor: colorTheme }),
      );
    }
    const browserDocument = this.browserService.document;
    if(browserDocument){
      browserDocument.documentElement.classList.toggle('dark', colorTheme === 'dark');
    }
  }

  private initLanguage() {
    let selectedLanguage: string = 'en'
    const url = this._router.url;
    const UrlFragments = this._router.url.split('/');
    const languageInUrl = this.includesAny(UrlFragments,['en', 'de', 'fa', 'id'])
    if(!languageInUrl) {
      const localStorageLanguage = this.browserService.localStorageGetItem('active-language')
      //if no value is saved in the localStorage.
      if(!localStorageLanguage){
        selectedLanguage = 'en'
        this.browserService.localStorageSetItem('active-language', 'en')
      } else {
        selectedLanguage = localStorageLanguage
      }
    } else {
      let languageInURL = UrlFragments[1]
      this.browserService.localStorageSetItem('active-language', languageInURL)
      selectedLanguage = languageInURL
    }
    this._store.dispatch(LanguageActions.setActiveLanguage({activeLanguage: selectedLanguage}))
    this._translateService.setDefaultLang(selectedLanguage)
    this._translateService.use(selectedLanguage)
    this._pageService.setDirection(selectedLanguage);

  }

  private includesAny(source: any[], values: any[]): boolean {
    return values.some(value => source.includes(value));
  }
}
